import { KapaLogoMark } from 'components/common/kapa-logo-mark';
import { cn } from 'lib/cn';

import { SidebarToggle } from './sidebar-toggle';

interface SidebarHeaderProps {
  teamName?: string;
  collapsed?: boolean;
  onToggle?: () => void;
}

export const SidebarHeader = ({
  teamName,
  collapsed = false,
  onToggle,
}: SidebarHeaderProps) => (
  <div
    className={cn(
      // Asymmetric padding keeps this row vertically centered with the page toolbar's title.
      'flex items-center pt-5 pb-4 transition-[padding]',
      collapsed ? 'justify-center px-2' : 'px-4',
    )}
  >
    {/* flex stays 1 (max-width collapses the width); animating flex would
        snap instead of fade. */}
    <div
      className={cn(
        'flex h-8 min-w-0 flex-1 items-center gap-1.5 overflow-hidden transition-[max-width,opacity]',
        collapsed ? 'max-w-0 pl-0 opacity-0' : 'max-w-full pl-1.5',
      )}
    >
      <KapaLogoMark
        aria-label="Kapa.ai logo"
        className="text-foreground size-5 shrink-0"
      />
      {teamName ? (
        <span className="text-headline text-foreground-secondary truncate">
          {teamName}
        </span>
      ) : null}
    </div>

    <SidebarToggle collapsed={collapsed} onToggle={onToggle} />
  </div>
);
